(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["muzsalesection"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Initialize Flickity slider
  var flkty = new Flickity('.products-holder', {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    freeScroll: true,
    groupCells: true
  });

  // Quantity selector functionality
  document.querySelectorAll('.quantity-button').forEach(button => {
    button.addEventListener('click', function() {
      const input = this.closest('.input-holder').querySelector('input[type="text"]');
      const currentValue = parseInt(input.value, 10);
      const increment = this.classList.contains('up') ? 1 : -1;
      const newValue = Math.max(1, currentValue + increment);
      input.value = newValue;
    });
  });

  // Add to cart functionality
  document.querySelectorAll('.add_to_cart').forEach(button => {
    button.addEventListener('click', function() {
      const productItem = this.closest('.product-item');
      const variantId = productItem.querySelector('input[type="radio"]:checked').dataset.variantId;
      const quantity = productItem.querySelector('input[name^="quantity"]').value;

      // Add to cart using Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: parseInt(quantity, 10)
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        // Handle successful add to cart
        console.log('Added to cart:', data);
        // You can add your own cart update logic here, e.g., update cart count or show a success message
        alert('Product added to cart successfully!');
      })
      .catch(error => {
        console.error('Error:', error);
        alert('There was an error adding the product to the cart. Please try again.');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productpageproducttitle"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var addToListButton = document.querySelector('.add_to_list');
  if (addToListButton) {
    addToListButton.addEventListener('click', function() {
      this.classList.toggle('is-added');
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
